import {
    URLAPI,
    EMPLOYEE_VEHICLE_CREATE_PATH,
} from "../config/index";
import {LOGOUT} from './users';
import axios from "axios";

const init = {
    _create_employee_vehicle: {
        data: {},
        status: 0,
        message: {},
    },
};

export const CREATE_EMPLOYEE_VEHICLE = "CREATE_EMPLOYEE_VEHICLE";

export const employee_vehicle_module = (state = init, action) => {
    switch (action.type) {
        case CREATE_EMPLOYEE_VEHICLE:
            return {
                ...state,
                _create_employee_vehicle: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
};


export const createEmployeeVehicle = (token, data) => async (dispatch) => {
    try {
        const response = await axios.post(
            `${URLAPI}${EMPLOYEE_VEHICLE_CREATE_PATH}`,
            data,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: CREATE_EMPLOYEE_VEHICLE,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: CREATE_EMPLOYEE_VEHICLE,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CREATE_EMPLOYEE_VEHICLE,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const clear_employee_vehicle = (type) => async (dispatch) => {
    dispatch({
        type: type,
        payload: {
            data: [],
            status: 0,
            message: {},
        },
    });
};
